function TermsAndConditions() {
    return (
        <div className="mx-auto w-11/12 md:w-4/5">
            <p>Date de dernière mise à jour : 15.05.2025</p>

            <h2 className="text-xl md:text-2xl font-bold mt-4 mb-2">1. Objet</h2>

            Les présentes Conditions Générales d’Utilisation (CGU) régissent l’accès et l’utilisation du site <a
            className="text-primary-light hover:underline"
            href="https://foti-immo.ch">https://foti-immo.ch</a> (ci-après "le Site").

            <h2 className="text-xl md:text-2xl font-bold mt-4 mb-2">2. Accès au Site</h2>

            Le Site est accessible gratuitement à tout utilisateur disposant d’un accès à Internet. L’ensemble des coûts
            afférents à l’accès (matériel, logiciel, connexion) sont à la charge de l’utilisateur.

            <h2 className="text-xl md:text-2xl font-bold mt-4 mb-2">3. Utilisation du Site</h2>

            L’utilisateur s’engage à ne pas utiliser le Site à des fins illicites ou contraires aux présentes CGU.

            Il est notamment interdit :
            <ul className="list-disc pl-4">
                <li>de fournir de fausses informations via les formulaires ;</li>
                <li>d’utiliser le Site pour envoyer des messages non sollicités (spam) ;</li>
                <li>d’entraver ou perturber le fonctionnement du Site.</li>
            </ul>

            <h2 className="text-xl md:text-2xl font-bold mt-4 mb-2">4. Services proposés</h2>

            Le Site permet notamment :
            <ul className="list-disc pl-4">
                <li>de contacter un courtier immobilier via un formulaire en ligne ;</li>
                <li>de faire une demande d’estimation immobilière.</li>
            </ul>

            Les services proposés sont informatifs et gratuits. L’estimation fournie n’a pas de valeur contractuelle
            et ne remplace pas une expertise officielle.

            <h2 className="text-xl md:text-2xl font-bold mt-4 mb-2">5. Propriété intellectuelle</h2>

            Le contenu du Site (textes, images, logo, etc.) est protégé par les lois en vigueur sur la propriété
            intellectuelle. Toute reproduction ou utilisation sans autorisation préalable est interdite.

            <h2 className="text-xl md:text-2xl font-bold mt-4 mb-2">6. Responsabilité</h2>

            Le propriétaire du Site s'efforce de garantir l'exactitude des informations publiées mais ne saurait
            être tenu responsable des erreurs, omissions ou indisponibilités du service.

            <h2 className="text-xl md:text-2xl font-bold mt-4 mb-2">7. Modification des CGU</h2>

            Les présentes CGU peuvent être modifiées à tout moment. L’utilisateur est invité à les consulter
            régulièrement.

            <h2 className="text-xl md:text-2xl font-bold mt-4 mb-2">8. Droit applicable</h2>

            Les présentes CGU sont régies par le droit suisse. En cas de litige, les tribunaux compétents seront
            ceux du siège du propriétaire du Site.

            <h2 className="text-xl md:text-2xl font-bold mt-4 mb-2">9. Contact</h2>

            Pour toute question relative aux présentes conditions :
            <p>FOTI Immobilier Sàrl</p>
            <p>Rue de Venise 8, 1870 Monthey, Suisse</p>
            <p>
                <a className="text-primary-light hover:underline" href="mailto:info@foti-immo.ch">info@foti-immo.ch</a>
            </p>
        </div>
    );
}

export default TermsAndConditions;